/**
 * The number two people agreed on, carried back to the deal.
 *
 * A vendor opens a card from a deal, argues eBay against TCGplayer with the
 * customer, digs into the individual sales, and settles on a figure. That
 * figure has to survive the trip back to the pricing screen.
 *
 * Deliberately a module variable and not router state or a query string. The
 * card screen returns with history.back, which restores the entry that was
 * already there rather than accepting a new one, and a price a customer is
 * standing over does not belong in a URL. It lives for one hop and is taken
 * exactly once, so a stale number can never be applied to a later card.
 */

let pending = null;

/** @param {string} cardId  the deal row's id, not the catalogue's */
export function offerPrice(cardId, price) {
  const value = Number(price);
  if (!cardId || !Number.isFinite(value) || value < 0) return;
  pending = { cardId, price: Math.round(value * 100) / 100 };
}

/** Reads and clears. A second caller gets nothing, which is the point. */
export function takePrice() {
  const held = pending;
  pending = null;
  return held;
}

/** Leaving a deal entirely should not leave a number waiting for the next one. */
export function clearPrice() {
  pending = null;
}
